var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClubReports(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5,21V4h6.25c-.08.33-.15.67-.2,1s-.07.67-.05,1h-4v6h7.25l.4,2h3.35v-1.15c.33,0,.67-.03,1-.08s.67-.13,1-.23v3.45h-7l-.4-2h-5.6v7h-2ZM17.28,8.1l3.48-3.45-1.05-1.05-2.43,2.38-.98-.98-1.05,1.08,2.03,2.03ZM18,.85c1.38,0,2.56.49,3.54,1.46s1.46,2.15,1.46,3.54-.49,2.56-1.46,3.54-2.15,1.46-3.54,1.46-2.56-.49-3.54-1.46-1.46-2.15-1.46-3.54.49-2.56,1.46-3.54,2.15-1.46,3.54-1.46Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClubReports);
export default __webpack_public_path__ + "static/media/club-reports.e89e1fe0d6bec79c051301b5f4e2aebb.svg";
export { ForwardRef as ReactComponent };